import axiosInsAcademy from '@/api/axios-ugems-academy';


export const GET_POSITION = (args) => {
    return axiosInsAcademy.get(`/positions`, { params: args });
}


